import React, { useState, useEffect } from 'react';
import { FaPrint, FaSave } from 'react-icons/fa';
import { Table, notification, Skeleton, Spin } from 'antd'; // Import Spin
import { LoadingOutlined } from '@ant-design/icons';


import './../../../css/BadgeAnt.css'
const log = (...args) => {
    console.log(...args);
};

export default function CpnDongTienLai({loanIdPayment}) {
    const [checkedItems, setCheckedItems] = useState({});
    const [checkedItemsDefault, setCheckedItemsDefault] = useState({});
    const [loading, setLoading] = useState(true); // Loading state for the skeleton
    const [loadingItem, setLoadingItem] = useState(false); // Track loading state for each row

   // console.log(loanIdPayment)


    const whiteSpinnerIcon = <LoadingOutlined style={{ fontSize: 24, color: 'white' }} spin />;


    const showNotification = (message, type) => {
        notification[type]({
            description: message,
            placement: 'topRight', // Notification position
        });
    };

    const handleSubmit = async () => {
       
        setLoadingItem(true);

        const changedItems = [];

        Object.keys(checkedItems).forEach((rowId) => {
            const defaultItem = checkedItemsDefault[rowId];
            const currentItem = checkedItems[rowId];
        
            // Kiểm tra xem có sự khác biệt trong trường PAY_MONEY hoặc DONE
            if (defaultItem.PAY_MONEY != currentItem.PAY_MONEY || defaultItem.DONE != currentItem.DONE) {
                let str_date = `Kỳ ${new Date(currentItem.FROM_DATE).toLocaleDateString('en-GB', {day: '2-digit',month: '2-digit',year: 'numeric'})}  -> ${new Date(currentItem.END_DATE).toLocaleDateString('en-GB', {day: '2-digit',month: '2-digit',year: 'numeric'})}`
                if (currentItem.DONE == 1) 
                    changedItems.push({"ROW_ID" : currentItem.ROW_ID, "DONE" : currentItem.DONE, "PAY_MONEY" : currentItem.PAY_MONEY, "PAYMENT_ID" : currentItem.PAYMENT_ID, "NOTE": str_date}); 
                else if (defaultItem.DONE == 1)
                    changedItems.push({"ROW_ID" : currentItem.ROW_ID, "DONE" : currentItem.DONE, "PAY_MONEY" : currentItem.PAY_NEED, "PAYMENT_ID" : currentItem.PAYMENT_ID, "NOTE": str_date});
            }
        });
        
      //  console.log(changedItems);

        const url = `${process.env.REACT_APP_API_DB_URL}/update-fast-payment-installment`;
        const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế
        
        const payload = {
            loanId: loanIdPayment,            
            data: changedItems,
        }

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`, // Thêm token vào headers
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
            let message = 'Không có thay đổi nào'
            if (response.status === 200){
                let responseData = await response.json(); // Parse the response as JSON
                message = `Cập nhật thành công, mã HĐ: ${responseData.loanId}`; // Assuming the response has a contractCode field
            }
                
            else if (response.status === 400)
                message = 'Cập nhật thất bại';            
            const type = response.ok ? 'success' : 'error';
            showNotification(message, type);
        } catch (error) {
            console.error('Error during fetch:', error);
        } finally {
            setLoadingItem(false);
            fetchData();
        }
    }
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        const token = localStorage.getItem('token'); // Thay 'your_token_key' bằng key thực tế
        fetch(`${process.env.REACT_APP_API_DB_URL}/payment-installment/${loanIdPayment}`,
            {
                method: 'GET', // Hoặc 'POST' nếu cần thiết
                headers: {
                    'Authorization': `Bearer ${token}`, // Thêm token vào headers
                    'Content-Type': 'application/json' // Nếu cần
                }
            })
            .then((response) => response.json())
            .then((data) => {
                const newCheckedItems = {};
                data.forEach((item) => {
                    let tmp = item
                    if (tmp.DONE === 0 ) tmp.PAY_MONEY = tmp.PAY_NEED
                    newCheckedItems[item.ROW_ID] = tmp;
                    
                });
                log(newCheckedItems);
                setCheckedItems(newCheckedItems);
                setCheckedItemsDefault(newCheckedItems);
                setLoading(false); // Set loading to false once data is fetched
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setLoading(false); // Even on error, stop loading
            });
    }
    const handleCheck = async (item) => {
        const id = item.ROW_ID;

        if (item.DONE) {
            const subsequentChecked = Object.keys(checkedItems).some((key) => {
                const rowId = parseInt(key, 10);
                return rowId > id && checkedItems[key].DONE;
            });

            if (subsequentChecked) {
                showNotification('Bạn phải xóa đóng lãi sau đó', 'error');
                return; // Prevent further execution
            }
        }
        else {
            // If the current item is being checked, ensure all previous unchecked items are also checked
            const updatedCheckedItems = { ...checkedItems };

            Object.keys(checkedItems).forEach((key) => {
                const rowId = parseInt(key, 10);
                if (rowId < id && !checkedItems[key].DONE) {
                    // Set previous unchecked rows to DONE
                    updatedCheckedItems[key] = {
                        ...updatedCheckedItems[key],
                        DONE: true
                    };
                }
            });

            setCheckedItems(updatedCheckedItems);
        }


        // Set loading state for this specific row
        // setLoadingItems((prevLoading) => ({
        //     ...prevLoading,
        //     [id]: true,
        // }));

        // setLoadingItem(true);

        // const url = item.DONE
        //     ? `${process.env.REACT_APP_API_DB_URL}/delete-fast-payment-credit`
        //     : `${process.env.REACT_APP_API_DB_URL}/insert-fast-payment-credit`;

        // const payload = {
        //     loanId: item.LOAN_ID,
        //     shopId: 1,
        //     paymentId: item.PAYMENT_ID,
        //     customerPay: item.PAY_MONEY,
        // };

        try {
            // const response = await fetch(url, {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify(payload),
            // });
            // const message = item.DONE
            //     ? 'Hủy đóng tiền thành công'
            //     : 'Đóng tiền thành công';
            // const type = response.ok ? 'success' : 'error';
            // showNotification(message, type);

            // Toggle DONE status after successful operation
            setCheckedItems((prevItems) => ({
                ...prevItems,
                [id]: {
                    ...prevItems[id],
                    DONE: !prevItems[id]?.DONE, // Toggle DONE status
                },
            }));
        } catch (error) {
            console.error('Error during fetch:', error);
        } finally {
            // Remove loading state for this specific row
            // setLoadingItems((prevLoading) => ({
            //     ...prevLoading,
            //     [id]: false,
            // }));

            // setLoadingItem(false);
        }
    };

    const handleInputChange = (id, value) => {
        // const parsedValue = value === "" ? 0 : parseInt(value, 10);
        let tmp = value.replace(/\./g, ''); // Xóa dấu chấm
        const parsedValue = tmp === "" ? 0 : parseInt(tmp, 10);
        setCheckedItems((prevItems) => ({
            ...prevItems,
            [id]: {
                ...prevItems[id],
                PAY_MONEY: isNaN(parsedValue) ? 0 : parsedValue, // Ensure PAY_MONEY is a valid number
            },
        }));
    };

    // Convert checkedItems object to an array for Ant Design Table data source
    const dataSource = Object.keys(checkedItems).map((key) => ({
        key,
        ...checkedItems[key],
    }));

    // Define table columns
    const columns = [
        {
            title: 'STT',
            dataIndex: 'ROW_ID',
            key: 'ROW_ID',
            width: 80,
            align: 'center',
        },
        {
            title: 'Ngày',
            key: 'DATE',
            render: (_, record) => (
                <>
                    {new Date(record.FROM_DATE).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    })} {' -> '}
                    {new Date(record.END_DATE).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric'
                    })}
                </>
            ),
        },
        {
            title: 'Số ngày',
            dataIndex: 'LOAN_TIME',
            key: 'LOAN_TIME',
            align: 'center',
        },
        {
            title: 'Tiền họ',
            dataIndex: 'PAY_NEED',
            key: 'PAY_NEED',
            align: 'center',
            render: (value) => value.toLocaleString('vi-VN')
        },
        {
            title: 'Tiền khách trả',
            key: 'PAY_MONEY',
            align: 'center',
            render: (_, record) => (
                <input
                    type="text"
                    className={`border border-gray-300 p-1 text-center ${record.DONE ? 'bg-gray-200' : ''}`}
                    value={record.PAY_MONEY ? Number(record.PAY_MONEY).toLocaleString('vi-VN') : ''}
                    disabled={record.DONE}
                    onChange={(e) => handleInputChange(record.ROW_ID, e.target.value)}
                />
            ),
        },
        {
    title: 'Thanh toán',
    key: 'DONE',
    align: 'center',
    render: (_, record) => (
        <div className='flex justify-center h-full'>
            <input
                type="checkbox"
                className="w-6 h-6"
                checked={record.DONE || false}
                onChange={() => handleCheck(record)}
                disabled={loadingItem} // Disable checkbox when loading
            />
        </div>
    ),
},
        {
            title: 'Ghi chú',
            dataIndex: 'NOTE',
            key: 'NOTE',
        },
    ];

    return (
        <div>
            <div className="mb-4">
                <h2 className="font-bold">Lịch sử đóng tiền lãi</h2>
            </div>
            {/* Show Skeleton if loading, else show Table */}
            {loading ? (
                <Skeleton active />
            ) : (
                <div>
                    <Table
                        dataSource={dataSource}
                        columns={columns}
                        pagination={false} // Disable pagination
                        scroll={{ x: '100%' }} // Enable horizontal scroll
                    />
                    <div className="flex flex-col items-center mt-4">
                        <button
                            className="bg-blue-500 text-white px-4 py-2 rounded flex items-center justify-center relative"
                            onClick={handleSubmit}
                        >
                            <FaSave className="mr-2" />
                            <span>Lưu lại</span>
                            {loadingItem && ( // Show Spin only when loading
                                <span className="ml-3">
                                    <Spin indicator={whiteSpinnerIcon} />
                                </span>
                            )}
                        </button>
                    </div>

                </div>



            )}
        </div>
    );
}
